import React from "react";
import type {VoidFunctionComponent} from "react";
import {WhenLessonInUserLibrary} from "../../modules/conditional/lesson-in-user-library/WhenLessonInUserLibrary";
import {
  SongDetailsLessonSongLibraryAction
} from "../../modules/lesson-song-library-action/SongDetailsLessonSongLibraryAction";
import {SongDetailsLessonPlayAction} from "../../modules/lesson-play-action/SongDetailsLessonPlayAction";
import {
  WhenLessonNotInUserLibrary
} from "../../modules/conditional/lesson-not-in-user-library/WhenLessonNotInUserLibrary";
import {WhenDeviceIOS} from "../../../../../../components/conditional/device/os/WhenDeviceIOS";
import {SongDetailsLessonNonPlayActionIos} from "../lesson-non-play-action-ios/SongDetailsLessonNonPlayActionIos";
import {WhenUserIsMember} from "../../../../../../components/conditional/user-is-member/WhenUserIsMember";
import {
  SongDetailsLessonNonPlayActionMember
} from "../lesson-non-play-action-member/SongDetailsLessonNonPlayActionMember";
import {
  SongDetailsLessonNonPlayActionNonMember
} from "../lesson-non-play-action-non-member/SongDetailsLessonNonPlayActionNonMember";
import {useSongDetailsDisplaySelectedLesson} from "../../hooks/useSongDetailsDisplaySelectedLesson";

export interface ISongDetailsLessonNoSongLibraryAccessActionsProps {
}

export const SongDetailsLessonNoSongLibraryAccessActions: VoidFunctionComponent<ISongDetailsLessonNoSongLibraryAccessActionsProps> = ({}) => {
  const {lessonId, firstLessonId} = useSongDetailsDisplaySelectedLesson();
  return (
    <>
      <WhenLessonInUserLibrary lessonID={lessonId ?? firstLessonId ?? 0}>
        <SongDetailsLessonSongLibraryAction />
        <SongDetailsLessonPlayAction />
      </WhenLessonInUserLibrary>
      <WhenLessonNotInUserLibrary lessonID={lessonId ?? firstLessonId ?? 0}>
        <WhenDeviceIOS>
          <SongDetailsLessonNonPlayActionIos />
        </WhenDeviceIOS>
        <WhenDeviceIOS not>
          <WhenUserIsMember>
            <SongDetailsLessonNonPlayActionMember lessonId={lessonId ?? firstLessonId ?? 0} />
          </WhenUserIsMember>
          <WhenUserIsMember not>
            <SongDetailsLessonNonPlayActionNonMember lessonId={lessonId ?? firstLessonId ?? 0} />
          </WhenUserIsMember>
        </WhenDeviceIOS>
      </WhenLessonNotInUserLibrary>
    </>
  );
}

